export type ClassificationType = {
  id: string;
  name: string;
  code: string;
  entity: string;
  origin: ClassificationTypeOriginEnum;
  useAsFilter: boolean;
  useAsTag: boolean;
  exhibitionOrder?: number | null;
};

export type Classification = {
  id: string;
  name: string;
  code: string;
  classificationType: ClassificationType;
  description?: string;
};

export enum ClassificationTypeEntityEnum {
  PRODUCT_COLOR = 'PRODUCT_COLOR',
  CUSTOMER = 'CUSTOMER',
}

export enum ClassificationTypeOriginEnum {
  TECEO = 'TECEO',
  INTEGRATION = 'INTEGRATION',
}

export enum ClassificationListTabValue {
  CLASSIFICATIONS = 'classifications',
  CLASSIFICATION_TYPES = 'classification-types',
}

export interface ListCustomerClassificationDTO {
  id: string;

  name: string;

  code: string;

  classificationType: ClassificationType;
}
